import { render } from "./detail-city.vue?vue&type=template&id=d4b43c3a&ts=true"
import script from "./detail-city.vue?vue&type=script&lang=ts"
export * from "./detail-city.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__